import React from "react";

const OpenSentence = () => {
  return (
    // <div className="terms-and-conditions-container">
    // {/* className="terms-and-conditions-p" */}

    <div
      className="terms-and-conditions-p"
      style={{
        boxShadow: "inset 0 -10px 10px -10px rgba(0,0,0,0.2)",
        maxWidth: "100%",
      }}
    >
      {/* <div className="tellAboutUsSection"> */}
      <br />
      <b> 💬 משפטי פתיחה קלילים ונעימים</b>
      <br />
      1. היי! ראיתי שהיינו התאמה בדאבל – וחשבתי שיהיה נחמד להכיר 😊
      <br />
      2. שלום 🙂 אז מסתבר שאנחנו דאבל! אולי נתחיל לדבר ולגלות למה?
      <br />
      3. היי, דאבל חיבר בינינו – בואי נראה אם הוא צדק 😉
      <br />
      4. היי! קיבלתי אותך כהתאמה, והאמת? נראה ממש מסקרן להכיר אותך 😊
      <br />
      5. אז... שנינו סימנו, ועכשיו זה הרגע לשבור את הקרח 😄
      <br />
      <br />
      <b>❤️ משפטים חמודים עם טאץ' אישי</b>
      <br />
      1. לא יודע/ת אם דאבל קורא מחשבות, אבל נראה שהוא קלע בול 😉
      <br />
      2. את/ה נראה/ת כמו מישהו ששווה להכיר – אז הנה אני פונה 😊
      <br />
      3. ראיתי שהתאמנו, וזה עשה לי חיוך. אולי תעזור/י לשמור עליו 😄
      <br />
      4. טוב, אז דאבל אמר שאת/ה מתאים/מה לי – בוא/י נבדוק אם גם אני מתאים/מה לך
      😉
      <br />
      5. לא נתחיל ישר בסמול טוק – רק אגיד שזה כיף לראות התאמה כזאת 🙂
      <br />
      <br />
      <b>🔥 משפטים עם קצת הומור</b>
      <br />
      1. אז... דאבל טוען שאנחנו מתאימים. אני אומר/ת ניתן לו צ'אנס להוכיח 😄
      <br />
      2. היי! אם זה לא הגורל – אז לפחות אלגוריתם ממש טוב 😉
      <br />
      3. נפגשנו פה כי שנינו סימנו – לפחות זה סימן אחד טוב 😅
      <br />
      4. מקווה שאת/ה לא ביישן/ית – כי אני החלטתי לשבור את הקרח 😉
      <br />
      5. דאבל עשה את החלק שלו – עכשיו תורנו! 😄
      <br />
      <br />
      <b>✨ משפטים קצת יותר רומנטיים או עמוקים</b>
      <br />
      1. אומרים שהכול מתחיל משיחה אחת קטנה… אז הנה היא 🙂
      <br />
      2. לפעמים הקשרים הכי טובים מתחילים ממש במקרה. אולי זה אחד מהם?
      <br />
      3. היי... אני לא יודעת איך זה ימשיך, אבל היה לי חשוב להגיד שלום 🙂
      <br />
      4. אם גם את/ה כאן בשביל להכיר באמת – אשמח להתחיל שיחה 🙏
      <br />
      5. אולי זה הסיפור שיספרו עליו "הכול התחיל מדאבל..." 😉
      <br />
      <br />
      📝 טיפ נוסף: אפשר גם להוסיף משפט אישי כמו: ראיתי שאת אוהבת טיולים – יש לך
      המלצה על מקום ששווה לבקר בו?
      <br />
    </div>
  );
};

export default OpenSentence;
